import React from "react";
import "./Footer.css";

function Footer() {
  // Функция для прокрутки наверх
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer" id="Footer">
      <div className="footer-content">
        {/* Информация о мастере */}
        <div className="footer-master-info">
          <div className="footer-logo">
            <div className="logo-icon">АТ</div>
            <div className="logo-text">Алена Трошина</div>
          </div>
          <p className="footer-description">
            Профессиональный мастер бьюти-индустрии с 10-летним опытом. Создаю
            индивидуальный образ для каждого клиента, используя современные
            техники и качественные материалы.
          </p>

          <div className="working-hours">
            <div className="hours-title">График работы</div>
            <div className="hours-list">
              <div className="hours-item">
                <span className="hours-day">Ежедневно</span>
                <span className="hours-time">10:00 - 20:00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Контакты */}
        <div className="footer-contacts">
          <h3 className="contact-title">Контакты</h3>

          <div className="contact-card">
            <div className="contact-icon">📱</div>
            <div className="contact-info">
              <div className="contact-name">Телефон для записи</div>
              <a href="tel:+79777990281" className="contact-value">
                +7 (977) 799-02-81
              </a>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-icon">✈️</div>
            <div className="contact-info">
              <div className="contact-name">Telegram</div>
              <a
                href="https://t.me/alena_brow1"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-value"
              >
                @alena_brow1
              </a>
            </div>
          </div>
        </div>

        {/* Правовая информация */}
        <div className="footer-social">
          <h3 className="contact-title">Информация</h3>
          
          <div className="legal-links">
            <a href="/policy" className="legal-link">
              <span className="legal-icon">🔒</span>
              Политика обработки персональных данных
            </a>
          </div>
        </div>
      </div>

      {/* Нижняя часть футера */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            © {new Date().getFullYear()} Алена Трошина. Все права защищены.
          </div>

          <button
            onClick={scrollToTop}
            className="back-to-top"
            aria-label="Наверх"
          >
            <span>↑</span>
            Наверх
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;